// Mask phone-looking strings in Sentry events before they leave the browser.
// Used only by App.jsx beforeSend — not a shared backend module.

const ISO_DATE_RE = /\b\d{4}-\d{2}-\d{2}\b/g;
const IPV4_RE = /\b(?:\d{1,3}\.){3}\d{1,3}\b/g;
const E164_RE = /\+\d[\d\s().-]{8,}\d/g;
const BARE_PHONE_RE = /(?<!\d)\d{10,15}(?!\d)/g;

function maskDigits(raw) {
  const digits = String(raw).replace(/\D/g, '');
  if (digits.length < 10 || digits.length > 15) return raw;
  return `+${digits.slice(0, 4)}****${digits.slice(-3)}`;
}

function maskPhonesInText(text) {
  if (typeof text !== 'string' || !text) return text;
  const held = [];
  const park = (m) => {
    held.push(m);
    return `\u0000${held.length - 1}\u0000`;
  };
  let next = text.replace(ISO_DATE_RE, park).replace(IPV4_RE, park);
  next = next.replace(E164_RE, maskDigits);
  next = next.replace(BARE_PHONE_RE, maskDigits);
  return next.replace(/\u0000(\d+)\u0000/g, (_, i) => held[Number(i)]);
}

export function maskPhonesInSentryEvent(event) {
  if (!event || typeof event !== 'object') return event;
  if (typeof event.message === 'string') {
    event.message = maskPhonesInText(event.message);
  }
  const values = event.exception && event.exception.values;
  if (Array.isArray(values)) {
    for (const v of values) {
      if (v && typeof v.value === 'string') {
        v.value = maskPhonesInText(v.value);
      }
    }
  }
  return event;
}

export function sentryBeforeSend(event) {
  return maskPhonesInSentryEvent(event);
}
